/* eslint-disable */
import { url } from 'configs/';
import deviceInfo from './deviceInfo';

/**
 * FIDO2 註冊服務
 * 專門處理 FIDO2 註冊流程的獨立服務
 */
class Fido2RegistrationService {
  constructor() {
    this.baseUrl = this._initializeBaseUrl();
    this.iframe = null;
    this.cleanupTimer = null;
  }

  /**
   * 初始化 API 基礎 URL
   * @private
   * @returns {string} 基礎 URL
   */
  _initializeBaseUrl() {
    // 優先使用配置文件中的 URL
    if (url.SECURITY_FIDO_API_SERVER) {
      return url.SECURITY_FIDO_API_SERVER;
    }

    // 嘗試從 runtime 配置獲取
    if (window.runtimeConfig && window.runtimeConfig.fidoApiUrl) {
      return window.runtimeConfig.fidoApiUrl;
    }

    // 使用預設值
    return 'https://uat-asiaauth.mayohr.com/api/';
  }

  /**
   * 將 ArrayBuffer 轉換為 base64url 字串
   * @param {ArrayBuffer} buffer - 要轉換的 ArrayBuffer
   * @returns {string} base64url 格式的字串
   */
  arrayBufferToBase64(buffer) {
    if (!buffer) return '';

    if (!(buffer instanceof ArrayBuffer)) {
      return '';
    }

    try {
      const uint8Array = new Uint8Array(buffer);

      // 處理大型 ArrayBuffer，避免堆疊溢出
      if (uint8Array.length > 32768) {
        let base64 = '';
        const chunkSize = 32768;
        for (let i = 0; i < uint8Array.length; i += chunkSize) {
          const chunk = uint8Array.slice(i, i + chunkSize);
          base64 += btoa(String.fromCharCode(...chunk));
        }
        return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
      } else {
        const base64 = btoa(String.fromCharCode(...uint8Array));
        return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
      }
    } catch (error) {
      return '';
    }
  }

  // ==================== 資料轉換工具方法 ====================

  /**
   * 將 Base64URL 轉換為 ArrayBuffer
   * @param {string} base64url - base64url 格式的字串
   * @param {number} maxBytes - 最大字節數限制，預設無限制
   * @returns {ArrayBuffer|null} 轉換後的 ArrayBuffer
   */
  base64urlToArrayBuffer(base64url, maxBytes = null) {
    if (!base64url || typeof base64url !== 'string') {
      return null;
    }

    if (base64url.length === 0) {
      return new ArrayBuffer(0);
    }

    try {
      // 驗證 base64url 格式
      if (!/^[A-Za-z0-9_-]*$/.test(base64url)) {
        return null;
      }

      // 轉換為 base64
      let base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
      const pad = base64.length % 4;
      if (pad) {
        base64 += '='.repeat(4 - pad);
      }

      const raw = window.atob(base64);
      const rawLength = raw.length;

      // 檢查長度限制
      if (maxBytes !== null && rawLength > maxBytes) {
        const truncatedRaw = raw.substring(0, maxBytes);
        const array = new Uint8Array(maxBytes);
        for (let i = 0; i < maxBytes; i++) {
          array[i] = truncatedRaw.charCodeAt(i);
        }
        return array.buffer;
      }

      const array = new Uint8Array(rawLength);
      for (let i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
      }
      return array.buffer;
    } catch (error) {
      return null;
    }
  }

  // ==================== 環境檢查方法（已停用）====================

  /**
   * 檢查 FIDO2 環境和憑證狀態
   * @returns {Object} 環境檢查結果
   * @deprecated 目前已停用環境檢查功能
   */
  // checkEnvironment() {
  //   // 檢查是否有混合內容
  //   const mixedContent = document.querySelectorAll(
  //     'script[src^="http:"], link[href^="http:"], img[src^="http:"]'
  //   );
  //   if (mixedContent.length > 0) {
  //   }

  //   // 檢查頁面是否完全載入
  //   if (document.readyState !== 'complete') {
  //   }

  //   // 檢查是否有憑證相關的錯誤訊息
  //   const bodyText = document.body.innerText || '';
  //   const hasCertError =
  //     bodyText.includes('certificate') ||
  //     bodyText.includes('憑證') ||
  //     bodyText.includes('安全') ||
  //     bodyText.includes('security') ||
  //     bodyText.includes('不受信任') ||
  //     bodyText.includes('untrusted');

  //   // 檢查瀏覽器是否顯示憑證警告
  //   const hasCertWarning =
  //     window.location.href.includes('chrome-error') ||
  //     window.location.href.includes('error') ||
  //     document.title.includes('Security') ||
  //     document.title.includes('安全');

  //   // 如果檢測到憑證問題，提供解決建議
  //   // if (hasCertError || hasCertWarning || mixedContent.length > 0) {
  //   // const errorMsg =
  //   //   '檢測到憑證問題：\n' +
  //   //   '1. 請檢查瀏覽器地址欄是否有警告圖示\n' +
  //   //   '2. 點擊鎖頭圖示查看憑證狀態\n' +
  //   //   '3. 如果有混合內容，請確保所有資源都使用 HTTPS\n' +
  //   //   '4. 嘗試重新整理頁面或清除瀏覽器快取';
  //   // alert(errorMsg);
  //   // 可以選擇繼續或停止
  //   // if (!confirm('檢測到憑證問題，是否仍要嘗試 FIDO2 註冊？')) {
  //   //   return {
  //   //     success: false,
  //   //     error: '用戶取消操作',
  //   //     details: '檢測到憑證問題，用戶選擇不繼續',
  //   //   };
  //   // }
  //   // }

  //   return {
  //     success: true,
  //     message: '環境檢查通過',
  //   };
  // }

  // ==================== iframe 管理方法 ====================

  /**
   * 創建隱藏的 iframe 並在目標網址設置 isReg: true
   * @param {string} targetUrl - 目標網址，預設為 x.com
   */
  // createSuccessIframe(targetUrl = 'https://tst-gauth.mayohr.com/HRM/account') {
  //   try {
  //     // 如果已經有 iframe 存在，先清理
  //     if (this.iframe) {
  //       console.log('清理現有的 iframe');
  //       this.cleanupIframe();
  //     }

  //     // 創建隱藏的 iframe
  //     this.iframe = document.createElement('iframe');
  //     this.iframe.style.display = 'none';
  //     this.iframe.style.width = '0';
  //     this.iframe.style.height = '0';
  //     this.iframe.style.border = 'none';
  //     this.iframe.style.position = 'absolute';
  //     this.iframe.style.left = '-9999px';
  //     this.iframe.style.top = '-9999px';

  //     // 方案1: URL 參數傳遞 - 將 isReg 作為 URL 參數傳遞
  //     const urlWithParams = this.buildUrlWithParams(targetUrl, {
  //       isReg: 'true',
  //       timestamp: Date.now(),
  //       source: 'fido2_registration',
  //     });

  //     // 設置 iframe 的 src，導向到目標網址
  //     this.iframe.src = urlWithParams;

  //     // 監聽 iframe 載入完成事件
  //     this.iframe.onload = () => {
  //       console.log('iframe 載入完成，URL 參數已傳遞至目標頁面');

  //       // 方案3: 同時嘗試 API 方式設置狀態
  //       this.setCrossDomainCookie(targetUrl);

  //       // 保留原有的 postMessage 方案作為備用
  //       try {
  //         this.iframe.contentWindow.postMessage(
  //           {
  //             type: 'SET_IS_REG',
  //             value: 'true',
  //             timestamp: Date.now(),
  //             source: 'fido2_registration',
  //           },
  //           targetUrl
  //         );
  //         console.log('已透過 postMessage 發送註冊狀態');
  //       } catch (postMessageError) {
  //         console.warn('postMessage 發送失敗:', postMessageError);
  //       }

  //       // 在載入完成後，延遲清理 iframe
  //       this.scheduleCleanup(2000, 'onload');
  //     };

  //     // 監聽錯誤事件
  //     this.iframe.onerror = (error) => {
  //       console.error('iframe 載入失敗:', error);
  //       // 如果載入失敗，也要清理 iframe
  //       this.scheduleCleanup(1000, 'onerror');
  //     };

  //     // 將 iframe 添加到 DOM
  //     document.body.appendChild(this.iframe);

  //     console.log('已創建註冊成功 iframe，將在目標頁面設置 isReg: true');

  //     // 設置超時清理機制，防止 iframe 永久存在
  //     this.scheduleCleanup(10000, 'timeout');
  //   } catch (error) {
  //     console.error('創建註冊成功 iframe 失敗:', error);
  //   }
  // }

  /**
   * 構建帶有參數的 URL
   * @param {string} baseUrl - 基礎 URL
   * @param {Object} params - 要添加的參數
   * @returns {string} 帶參數的完整 URL
   */
  // buildUrlWithParams(baseUrl, params) {
  //   try {
  //     const url = new URL(baseUrl);

  //     // 添加參數到 URL
  //     Object.keys(params).forEach((key) => {
  //       url.searchParams.set(key, params[key]);
  //     });

  //     console.log('構建的目標 URL:', url.toString());
  //     return url.toString();
  //   } catch (error) {
  //     console.error('URL 構建失敗:', error);
  //     return baseUrl; // 如果失敗，返回原始 URL
  //   }
  // }

  /**
   * 設置跨域 Cookie (需要服務端支持)
   * @param {string} targetUrl - 目標網址
   */
  // setCrossDomainCookie(targetUrl) {
  //   try {
  //     // 方案2: 發送 API 請求到目標域名設置 Cookie
  //     const apiUrl = new URL('/api/set-reg-status', targetUrl);

  //     fetch(apiUrl.toString(), {
  //       method: 'POST',
  //       credentials: 'include', // 包含 cookies
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         isReg: 'true',
  //         timestamp: Date.now(),
  //         source: 'fido2_registration',
  //       }),
  //     })
  //       .then((response) => {
  //         if (response.ok) {
  //           console.log('成功透過 API 設置註冊狀態');
  //         } else {
  //           console.warn('API 設置註冊狀態失敗:', response.status);
  //         }
  //       })
  //       .catch((error) => {
  //         console.warn('Cookie 設置請求失敗:', error);
  //       });
  //   } catch (error) {
  //     console.error('跨域 Cookie 設置失敗:', error);
  //   }
  // }

  /**
   * 統一管理清理 iframe 的時間調度
   * @param {number} delay - 延遲時間（毫秒）
   * @param {string} reason - 清理原因
   */
  // scheduleCleanup(delay, reason) {
  //   // 清除之前的清理計時器
  //   if (this.cleanupTimer) {
  //     clearTimeout(this.cleanupTimer);
  //     this.cleanupTimer = null;
  //   }

  //   // 設置新的清理計時器
  //   this.cleanupTimer = setTimeout(() => {
  //     console.log(`iframe 清理觸發 (${reason})`);
  //     this.cleanupIframe();
  //   }, delay);
  // }

  /**
   * 清理隱藏的 iframe
   */
  // cleanupIframe() {
  //   // 清除清理計時器
  //   if (this.cleanupTimer) {
  //     clearTimeout(this.cleanupTimer);
  //     this.cleanupTimer = null;
  //   }

  //   // 清理 iframe
  //   if (this.iframe) {
  //     // 移除事件監聽器
  //     if (this.iframe.onload) {
  //       this.iframe.onload = null;
  //     }
  //     if (this.iframe.onerror) {
  //       this.iframe.onerror = null;
  //     }

  //     // 從 DOM 移除
  //     if (this.iframe.parentNode) {
  //       this.iframe.parentNode.removeChild(this.iframe);
  //     }

  //     this.iframe = null;
  //     console.log('已清理註冊成功 iframe');
  //   }
  // }

  // ==================== FIDO2 註冊流程核心方法 ====================

  /**
   * 請求 FIDO2 註冊
   * @param {string} companyCode - 公司代碼
   * @param {string} employeeNumber - 員工編號
   * @param {Function} callback - 回調函數，參數為 (error, regData)
   */
  requestRegistration(companyCode, employeeNumber, callback) {
    deviceInfo
      .getFido2DeviceInfo()
      .then((deviceData) => {
        // 將原來的 XMLHttpRequest 代碼移到這裡
        const xhr = new XMLHttpRequest();

        const requestUrl = this.baseUrl + 'FidoGateway/Fido2/requestReg';

        xhr.open('POST', requestUrl, true);

        xhr.setRequestHeader('Content-Type', 'application/json');

        xhr.withCredentials = true; // 包含 cookies 和認證資訊`

        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              try {
                const regData = JSON.parse(xhr.responseText);

                // 驗證回應資料結構
                if (!regData) {
                  callback(new Error('API 回應為空'), null);
                  return;
                }

                if (!regData.data) {
                  callback(new Error('API 回應缺少 data 欄位'), null);
                  return;
                }

                // 檢查必要欄位
                const requiredFields = ['challenge', 'user', 'rp'];
                for (let i = 0; i < requiredFields.length; i++) {
                  const field = requiredFields[i];
                  if (!regData.data[field]) {
                    callback(new Error('API 回應缺少必要欄位: ' + field), null);
                    return;
                  }
                }

                // 檢查 user 子欄位
                if (
                  !regData.data.user.id ||
                  !regData.data.user.name ||
                  !regData.data.user.displayName
                ) {
                  callback(new Error('API 回應中 user 欄位不完整'), null);
                  return;
                }

                // 檢查 rp 子欄位
                if (!regData.data.rp.id) {
                  callback(new Error('API 回應中 rp 欄位不完整'), null);
                  return;
                }

                callback(null, regData);
              } catch (parseError) {
                callback(
                  new Error('JSON 解析失敗: ' + parseError.message),
                  null
                );
              }
            } else {
              callback(
                new Error(
                  '第一支 API 失敗: ' + xhr.status + ' - ' + xhr.responseText
                ),
                null
              );
            }
          }
        };

        xhr.onerror = () => {
          callback(new Error('網路請求失敗'), null);
        };

        const requestBody = {
          bodyHeaderRequest: {
            userIp: deviceData.userIp,
            deviceType: deviceData.deviceType,
            deviceUuid: deviceData.deviceUuid,
            deviceBrand: deviceData.deviceBrand,
            deviceVersion: deviceData.deviceVersion,
            companyCode: companyCode,
            employeeNumber: employeeNumber,
          },
          displayName: `${companyCode}-${employeeNumber}`,
          origin: `${window.location.protocol}//${window.location.host}`,
          // 後端(FIDO-GATEWAY)幫忙傳到偉康 前端不傳遞
          // rpId: window.location.hostname,
          // attestation: 'none',
          // extensions: {
          //   additionalProp1: 'none',
          //   additionalProp2: 'none',
          //   additionalProp3: 'none',
          // },
        };

        xhr.send(JSON.stringify(requestBody));
      })
      .catch((error) => {
        callback(error, null);
      });
  }

  /**
   * 準備 FIDO2 註冊配置
   * @param {Object} regData - 註冊回應資料
   * @returns {Object} 準備好的註冊配置
   */
  prepareRegistrationConfig(regData) {
    // 轉換 User ID - 使用 64 bytes 限制

    const userIdArrayBuffer = this.base64urlToArrayBuffer(
      regData.data.user.id,
      64
    );

    if (!userIdArrayBuffer) {
      throw new Error(`User ID 轉換失敗: ${regData.data.user.id}`);
    }

    // 轉換 Challenge - 使用更寬鬆的限制（通常 Challenge 可以更長）

    const challengeArrayBuffer = this.base64urlToArrayBuffer(
      regData.data.challenge
    );

    if (!challengeArrayBuffer) {
      throw new Error(`Challenge 轉換失敗: ${regData.data.challenge}`);
    }

    const regConfig = {
      rp: regData.data.rp,
      allowCredentials: regData.data.allowCredentials
        ? regData.data.allowCredentials
            .map((cred) => {
              const idBuffer = this.base64urlToArrayBuffer(cred.id);
              if (!idBuffer) {
                return null;
              }
              const newCred = {};
              for (const key in cred) {
                if (cred.hasOwnProperty(key)) {
                  newCred[key] = cred[key];
                }
              }
              newCred.id = idBuffer;
              return newCred;
            })
            .filter((cred) => cred !== null)
        : undefined,
      user: {
        id: userIdArrayBuffer,
        name: regData.data.user.name,
        displayName: regData.data.user.displayName,
      },
      challenge: challengeArrayBuffer,
      pubKeyCredParams: regData.data.pubKeyCredParams,
      timeout: regData.data.timeout,
      excludeCredentials: regData.data.excludeCredentials
        ? regData.data.excludeCredentials
            .map((cred) => {
              const idBuffer = this.base64urlToArrayBuffer(cred.id);
              if (!idBuffer) {
                return null;
              }
              const newCred = {};
              for (const key in cred) {
                if (cred.hasOwnProperty(key)) {
                  newCred[key] = cred[key];
                }
              }
              newCred.id = idBuffer;
              return newCred;
            })
            .filter((cred) => cred !== null)
        : undefined,
      authenticatorSelection: {
        authenticatorAttachment:
          regData.data.authenticatorSelection.authenticatorAttachment,
        residentKey: regData.data.authenticatorSelection.residentKey,
        requireResidentKey:
          regData.data.authenticatorSelection.requireResidentKey === 'true',
        userVerification: regData.data.authenticatorSelection.userVerification,
      },
      attestation: regData.data.attestation,
      extensions: regData.data.extensions || undefined,
    };

    return regConfig;
  }

  /**
   * 驗證註冊配置
   * @param {Object} regConfig - 註冊配置
   */
  validateRegistrationConfig(regConfig) {
    // 檢查必要欄位
    if (!regConfig.challenge) {
      throw new Error('Challenge 轉換失敗');
    }

    if (!regConfig.user.id) {
      throw new Error('User ID 轉換失敗');
    }

    if (!(regConfig.user.id instanceof ArrayBuffer)) {
      throw new Error(
        `User ID 不是 ArrayBuffer 類型，實際類型: ${typeof regConfig.user.id}`
      );
    }

    if (regConfig.user.id.byteLength > 64) {
      throw new Error(
        `User ID 長度 ${regConfig.user.id.byteLength} bytes 超過 64 bytes 限制`
      );
    }
  }

  /**
   * 創建 FIDO2 憑證
   * @param {Object} regConfig - 註冊配置
   * @param {Function} callback - 回調函數，參數為 (error, credential)
   */
  createCredential(regConfig, callback) {
    navigator.credentials
      .create({
        publicKey: regConfig,
      })
      .then((credential) => {
        callback(null, credential);
      })

      .catch((error) => {
        // console.log('WebAuthn 錯誤詳情:', error);

        switch (error.name) {
          case 'NotAllowedError':
            // 檢查是否為重複註冊的情況
            if (
              regConfig.excludeCredentials &&
              regConfig.excludeCredentials.length > 0
            ) {
              // console.log('⚠️ FIDO2 使用者已註冊過（excludeCredentials 檢測），跳過註冊流程');
              callback(null, {
                success: false,
                message: 'FIDO2 使用者已註冊過',
                isRegistered: true,
              });
            } else {
              console.error('❌ 操作被拒絕:', error.message);
              callback(error, null);
            }
            break;

          case 'InvalidStateError':
            // console.log('⚠️ FIDO2 使用者已註冊過，跳過註冊流程');
            callback(null, {
              success: false,
              message: 'FIDO2 使用者已註冊過',
              isRegistered: true,
            });
            break;

          case 'NotSupportedError':
            console.error('❌ 瀏覽器或設備不支援 WebAuthn:', error.message);
            callback(error, null);
            break;

          case 'SecurityError':
            console.error('❌ 安全錯誤，請確保使用 HTTPS:', error.message);
            callback(error, null);
            break;

          case 'AbortError':
            // console.log('⚠️ 操作被中止:', error.message);
            callback(error, null);
            break;

          case 'ConstraintError':
            console.error('❌ 參數約束錯誤:', error.message);
            callback(error, null);
            break;
          default:
            console.error('❌ 未知錯誤:', error.name, error.message);
            callback(error, null);
        }
      });
  }

  /**
   * 完成 FIDO2 註冊
   * @param {Object} regData - 註冊回應資料
   * @param {Object} credential - 創建的憑證
   * @param {string} companyCode - 公司代碼
   * @param {string} employeeNumber - 員工編號
   * @param {Function} callback - 回調函數，參數為 (error, completeData)
   */
  completeRegistration(
    regData,
    credential,
    companyCode,
    employeeNumber,
    callback
  ) {
    deviceInfo
      .getFido2DeviceInfo()
      .then((deviceData) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', this.baseUrl + 'FidoGateway/Fido2/doReg', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.withCredentials = true;

        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              try {
                // console.log('原始回應內容:', xhr.responseText);
                // console.log('回應內容類型:', typeof xhr.responseText);
                // console.log(
                //   '回應內容長度:',
                //   xhr.responseText ? xhr.responseText.length : 0
                // );

                if (!xhr.responseText) {
                  callback(new Error('API 回應內容為空'), null);
                  return;
                }

                const completeData = JSON.parse(xhr.responseText);
                // console.log('解析後的 completeData:', completeData);
                callback(null, completeData);
              } catch (parseError) {
                console.error('JSON 解析錯誤:', parseError);
                console.error('無法解析的內容:', xhr.responseText);
                callback(
                  new Error(
                    'JSON 解析失敗: ' +
                      parseError.message +
                      ' | 原始回應: ' +
                      xhr.responseText
                  ),
                  null
                );
              }
            } else {
              callback(
                new Error(
                  '完成註冊 API 失敗: ' + xhr.status + ' - ' + xhr.responseText
                ),
                null
              );
            }
          }
        };

        xhr.onerror = () => {
          callback(new Error('網路請求失敗'), null);
        };

        const requestBody = {
          bodyHeaderRequest: {
            userId: regData.data.user.id,
            companyCode: companyCode,
            employeeNumber: employeeNumber,
            userIp: deviceData.userIp,
            appVersion: deviceData.appVersion,
            deviceType: deviceData.deviceType,
            deviceUuid: deviceData.deviceUuid,
            deviceBrand: deviceData.deviceBrand,
            deviceVersion: deviceData.deviceVersion,
          },
          userName: regData.data.user.name,
          rpId: regData.data.rp.id,
          regPublicKeyCredential: {
            id: credential.id,
            type: 'public-key',
            rawId: this.arrayBufferToBase64(credential.rawId),
            response: {
              clientDataJSON: this.arrayBufferToBase64(
                credential.response.clientDataJSON
              ),
              attestationObject: this.arrayBufferToBase64(
                credential.response.attestationObject
              ),
              userHandle: credential.response.userHandle
                ? this.arrayBufferToBase64(credential.response.userHandle)
                : undefined,
            },
          },
          regId: regData.data.user.id,
        };

        xhr.send(JSON.stringify(requestBody));
      })
      .catch((error) => {
        callback(error, null);
      });
  }

  // ==================== 主要執行方法 ====================

  /**
   * 執行完整的 FIDO2 註冊流程
   * @param {string} companyCode - 公司代碼
   * @param {string} employeeNumber - 員工編號
   * @param {Function} callback - 回調函數，參數為 (error, result)
   */
  executeRegistration(companyCode, employeeNumber, callback) {
    console.log('🚀 開始執行 FIDO2 註冊流程');

    try {
      this._executeRegistrationSteps(companyCode, employeeNumber, callback);
    } catch (error) {
      console.error('💥 executeRegistration 同步錯誤:', error);
      callback(error, null);
    }
  }

  /**
   * 執行註冊步驟
   * @private
   * @param {string} companyCode - 公司代碼
   * @param {string} employeeNumber - 員工編號
   * @param {Function} callback - 回調函數
   */
  _executeRegistrationSteps(companyCode, employeeNumber, callback) {
    // console.log('📡 開始請求註冊...');

    this.requestRegistration(companyCode, employeeNumber, (error, regData) => {
      if (error) {
        console.error('❌ requestRegistration 失敗:', error);
        this._handleRegistrationError(error, callback);
        return;
      }

      // console.log('✅ requestRegistration 成功，開始準備配置...');

      try {
        // 步驟 3: 準備配置
        const regConfig = this.prepareRegistrationConfig(regData);

        this.validateRegistrationConfig(regConfig);

        // 步驟 4: 創建憑證
        this.createCredential(regConfig, (error, result) => {
          if (error) {
            this._handleRegistrationError(error, callback);
            return;
          }

          // 檢查是否已註冊，如果是則直接返回，不繼續後續流程
          if (result && result.isRegistered) {
            // console.log('⚠️ 檢測到使用者已註冊，直接返回結果');
            // console.log('result:', result);
            callback(null, result);
            return;
          }

          // 步驟 5: 完成註冊
          this.completeRegistration(
            regData,
            result, // 這裡應該是 result（credential 對象）
            companyCode,
            employeeNumber,
            (error, completeData) => {
              // 處理錯誤情況
              if (error) {
                console.error('completeRegistration 錯誤:', error);
                this._handleRegistrationError(error, callback);
                return;
              }

              // 記錄並驗證回應資料
              // console.log('完整的 completeData:', completeData);

              // completeData 格式：
              //   {
              //     "code": 0,
              //     "message": "OK"
              //   }

              // 驗證回應資料
              if (!completeData) {
                console.error('completeData 為空');
                callback(null, {
                  success: false,
                  error: 'API 回應為空',
                  message: 'FIDO2 註冊失敗：服務器無回應',
                });
                return;
              }

              if (typeof completeData.code === 'undefined') {
                console.error(
                  'completeData.code 不存在，完整回應:',
                  completeData
                );
                callback(null, {
                  success: false,
                  error: 'API 回應缺少 code 欄位',
                  details: completeData,
                  message: 'FIDO2 註冊失敗：回應缺少狀態碼',
                });
                return;
              }

              // console.log('API 回應狀態碼:', completeData.code);
              // console.log('API 回應訊息:', completeData.message);

              this._handleRegistrationResult(completeData, callback);
            }
          );
        });
      } catch (error) {
        this._handleRegistrationError(error, callback);
      }
    });
  }

  /**
   * 處理註冊結果
   * @private
   * @param {Object} completeData - 完成註冊的回應資料
   * @param {Function} callback - 回調函數
   */
  _handleRegistrationResult(completeData, callback) {
    if (completeData.code === 0) {
      // 註冊成功時創建 iframe 並設置 isReg: true
      this.createSuccessIframe();
      this._handleRegistrationSuccess(completeData, null, callback);
    } else if (completeData.code === 1) {
      callback(null, {
        success: false,
        code: completeData.code,
        data: completeData,
        message: 'FIDO2 註冊失敗',
      });
    } else {
      callback(null, {
        success: false,
        code: completeData.code,
        data: completeData,
        message: `未知的回應碼: ${completeData.code}`,
      });
    }
  }
  /**
   * 統一處理註冊錯誤（對上層以 result 物件回傳失敗狀態）
   * @private
   */
  _handleRegistrationError(error, callback) {
    callback(null, {
      success: false,
      error: error && error.message ? error.message : String(error),
      details: error,
      message: 'FIDO2 註冊流程執行失敗',
    });
  }

  /**
   * 統一處理註冊成功（對上層以 result 物件回傳成功狀態）
   * @private
   */
  _handleRegistrationSuccess(completeData, credential, callback) {
    var isSuccess = completeData.code === 0;
    callback(null, {
      success: isSuccess,
      code: completeData.code,
      data: completeData,
      credential: credential,
      message: isSuccess ? 'FIDO2 註冊成功' : 'FIDO2 註冊失敗',
    });
  }
}

// 創建單例實例
const fido2RegistrationService = new Fido2RegistrationService();

export default fido2RegistrationService;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/utils/fido2RegistrationService.js
 **/